<template>
  <div>
    <teleport
      to="#mobile-popover"
      append
    >
      <div
        class="mobile-popover block sm:hidden"
        :class="{'mobile-popover--full-height': fullHeight}"
        @click="clickBackground"
      >
        <div
          class="mobile-popover__body"
          ref="body"
          :class="{'mobile-popover__body--full-height': fullHeight}"
        >
          <Header
            :title="title"
            :action-label="headerAction"
            :icon-name="iconName"
            icon-position="left"
            @action="$emit('headerAction')"
            @close="$emit('close')"
          />

          <div :class="contentClasses">
            <slot />
          </div>

          <div :class="{'mobile-popover__actions-wrapper--fixed': actionButtonsFixedPosition}">
            <slot name="actions" />
          </div>

          <ActionsWrapper
            v-if="action"
            :class="{'mobile-popover__actions-wrapper--fixed': actionButtonsFixedPosition}"
          >
            <BaseButton
              color="green"
              class="w-full"
              :is-loading="isActionLoading"
              @click="$emit('action')"
            >
              {{ action }}
            </BaseButton>
          </ActionsWrapper>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import ActionsWrapper from '../ActionsWrapper.vue';
import BaseButton from '../Buttons/BaseButton.vue';
import Header from './Header.vue';

export default {
  name: 'MobilePopover',
  components: { BaseButton, ActionsWrapper, Header },
  props: {
    action: {
      type: String,
      default: '',
    },
    headerAction: {
      type: String,
      default: '',
    },
    isActionLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    lockBackgroundScroll: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: 'close-icon',
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    blockOutsideClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actionButtonsFixedPosition: false,
      lockedScrollTop: 0,
      hasLockedScroll: false,
    };
  },
  computed: {
    contentClasses() {
      let result = 'mobile-popover__content';
      if (this.actionButtonsFixedPosition) {
        result += ' pb-20';
      }
      if (!this.noPadding) {
        result += ' p-4';
      }
      return result;
    },
  },
  methods: {
    clickBackground(event) {
      if (this.blockOutsideClick) {
        return;
      }

      if (this.$refs.body && !this.$refs.body.contains(event.target)) {
        this.$emit('close');
      }
    },
    disableBackgroundScroll() {
      if (document.documentElement.classList.contains('disabled-scroll')) {
        return;
      }
      this.lockedScrollTop = document.documentElement.scrollTop;
      document.documentElement.style.top = `-${this.lockedScrollTop}px`;
      document.documentElement.classList.add('disabled-scroll');
      this.hasLockedScroll = true;
    },
    enableBackgroundScroll() {
      document.documentElement.classList.remove('disabled-scroll');
      document.documentElement.style.removeProperty('top');
      document.documentElement.scrollTop = this.lockedScrollTop;
    },
    handleOverflow() {
      // This function aims to put the Action Buttons with the fixed position on the bottom of the screen IF the Popover is bigger than the screen
      // It puts Action Buttons with position: static otherwise
      const height = this.$refs.body.getBoundingClientRect().height;
      const screenHeight = window.innerHeight;
      if (height > screenHeight) {
        this.actionButtonsFixedPosition = true;
      }
    },
  },
  mounted() {
    if (this.lockBackgroundScroll) {
      this.disableBackgroundScroll();
    }
    setTimeout(this.handleOverflow);
  },
  beforeUnmount() {
    if (this.hasLockedScroll) {
      this.enableBackgroundScroll();
    }
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;

.mobile-popover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.15);
  overflow-y: scroll;
}
.mobile-popover--full-height {
  background: ds-variables.$white;
}

.mobile-popover__body {
  background: ds-variables.$white;
  position: relative;
}

.mobile-popover__body--full-height {
  min-height: 100%;
}

.mobile-popover__actions-wrapper--fixed {
  background: ds-variables.$white;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.basis-20 {
  flex-basis: 20%;
}

.basis-60 {
  flex-basis: 60%;
}
</style>
